// extracted by mini-css-extract-plugin
export default {"root":"W1tct","icon":"NMiNY","tooltip":"_2zFBy"};